import { Component, OnInit, Input, HostBinding, AfterViewInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RadioCardInterface } from 'src/app/core/interfaces/radio-card.interface';

@Component({
  selector: 'app-summary-legal',
  templateUrl: './summary-legal.component.html',
  styleUrls: ['./summary-legal.component.scss']
})
export class SummaryLegalComponent implements OnInit, AfterViewInit {

  @Input() FORM_DATA: FormGroup;
  /**
   * @description Es la configuracion del formulario
   */
  @Input() DATA_CONFIG: any;

  // @HostBinding( 'class.contratacion__detail' ) apply = true;

  insureSelected: { name: string, chosed: string };
  nameProductSelected = '';

  @HostBinding('class.contratacion__detail') apply = true;
  /**
   * @description constructor
   */
  constructor() {
  }
  /**
   * @description metodo inicio
   */
  ngOnInit(): void {
    this.getProductChoosed();
    const AUX_NAME_PRODUCT_SELECTED: any = this.FORM_DATA.get([this.insureSelected.chosed, 'insuranceType']).value;
    this.nameProductSelected = AUX_NAME_PRODUCT_SELECTED.title;
  }
  /**
   * @description recuprar prodcuto
   */
  getProductChoosed(): void {
    if (this.FORM_DATA) {
      this.insureSelected = this.FORM_DATA.get('insureSelected').value;
    }
  }
  /**
   * @description recupara valor del formulario
   * @params prop
   */
  getFormValue(prop: string[]): RadioCardInterface | string | number {
    if (this.FORM_DATA) {
      return this.FORM_DATA.get(prop).value;
    }
  }
  /**
   * @description recuparar pais destino
   */
  getCountryDestiny(): string {
    let returnV: string;
    const CHOSED: any = this.getFormValue([this.insureSelected.chosed, 'countryDestiny']);
    if (Array.isArray(CHOSED)) {
      returnV = CHOSED[0].name;
    } else {
      returnV = CHOSED.name;
    }
    return returnV;
  }
  /**
   * activa el desplegable en la version movil
   */
  ngAfterViewInit(): void {
    const linkToggle: NodeListOf<Element> = document.querySelectorAll('.js-toggle');
    linkToggle.forEach(element => {
      element.addEventListener('click', function(event: Event): void {
        event.preventDefault();
        const container: HTMLElement = document.getElementById(this.dataset.container);
        if (container.classList.contains('active')) {
          container.classList.add('inactive');
          container.classList.remove('active');
        } else {
          container.classList.add('active');
          container.classList.remove('inactive');
        }
      });
    });
  }

}
